// * Bootstrap libraries
import "./_bootstrap";

// * Any other global site-wide JavaScript should be placed below.


    document.addEventListener('DOMContentLoaded', function() {
    var colorChangeTexts = document.querySelectorAll('.color-change');
    var previousScrollPosition = 0;

    colorChangeTexts.forEach(function(element) {
    var text = element.textContent;
    element.textContent = '';

    for (var i = 0; i < text.length; i++) {
    // Erstelle ein neues Span-Element für jeden Buchstaben
    var span = document.createElement('span');
    span.textContent = text[i];
    element.appendChild(span);
}
});

    // EventListener für das Scrollen hinzufügen
    document.addEventListener('scroll', function() {
    var currentScrollPosition = window.pageYOffset;
    var scrollDirection = currentScrollPosition > previousScrollPosition ? 'down' : 'up';
    previousScrollPosition = currentScrollPosition;

    colorChangeTexts.forEach(function(element) {
    var spans = element.querySelectorAll('span');
    var elementPosition = element.getBoundingClientRect().top;
    var viewportHeight = window.innerHeight;
    var elementHeight = element.clientHeight;
    var scrolledPercentage;

    // Überprüfe, ob der Absatz sichtbar ist
    if (elementPosition < viewportHeight && elementPosition + elementHeight >= 0) {
    scrolledPercentage = (elementPosition + elementHeight / 2) / viewportHeight;

    spans.forEach(function(span, index) {
    // Ändere die Farbe basierend auf der Scrollrichtung
    var colorIndex;
    if (scrollDirection === 'up') {
    colorIndex = Math.floor(scrolledPercentage * spans.length);
    if (index <= colorIndex) {
    span.style.color = getComputedStyle(document.documentElement).getPropertyValue('--end-color'); // Endfarbe
} else {
    span.style.color = getComputedStyle(document.documentElement).getPropertyValue('--end-color'); // Startfarbe
}
} else if (scrollDirection === 'down') {
    colorIndex = spans.length - Math.floor(scrolledPercentage * spans.length);
    if (index >= colorIndex) {
    span.style.color = getComputedStyle(document.documentElement).getPropertyValue('--start-color'); // Startfarbe
} else {
    span.style.color = getComputedStyle(document.documentElement).getPropertyValue('--end-color'); // Endfarbe
}
}
});
}
});
});
});
